export enum ContratBeneficiaryStatus {
  inCharge = 'Responsable',
  partner = 'Conjoint',
}
